var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7375 1.49961C6.88247 1.49961 7 1.38207 7 1.23711V0.362109C7 0.217144 6.88247 0.0996094 6.7375 0.0996094H0.2625C0.117534 0.0996094 0 0.217144 0 0.362109V1.34097C0 1.48594 0.117534 1.60347 0.2625 1.60347H2.128C2.72536 1.60347 3.18371 1.8213 3.46172 2.19961H0.2625C0.117534 2.19961 0 2.31714 0 2.46211V3.33711C0 3.48207 0.117534 3.59961 0.2625 3.59961H3.73531C3.59931 4.38899 3.01429 4.88218 2.1 4.88218H0.2625C0.117534 4.88218 0 4.99972 0 5.14468V6.30432C0 6.37758 0.030625 6.44752 0.0844594 6.49722L3.69497 9.83C3.74346 9.87475 3.80703 9.89961 3.87301 9.89961H5.67906C5.91802 9.89961 6.03269 9.60631 5.8571 9.44421L2.55655 6.39755C4.22997 6.34637 5.42533 5.22954 5.58226 3.59961H6.7375C6.88247 3.59961 7 3.48207 7 3.33711V2.46211C7 2.31714 6.88247 2.19961 6.7375 2.19961H5.45366C5.3774 1.94715 5.27253 1.71298 5.14189 1.49961H6.7375Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesIcon);
export default __webpack_public_path__ + "static/media/RupeesIcon.c16a2a41f499a1860609e64410bb23e4.svg";
export { ForwardRef as ReactComponent };